/**
 * Encode quotes and backslash in query
 */
const encode = (string: string): string => (
  string
    .replace(/\n/g, '')
    .replace(/\\/g, '\\\\')
    .replace(/"/g, '\\"')
)

const reduceMethod = (params: { [key: string]: any }, queryParamsKeysArray: any[], isEnum: boolean) =>
  (query: string, param: any, currentIndex: number) => {
    let value = params[param]

    if (typeof value === 'undefined' || value === null || value === '') {
      return query
    }

    if (typeof value === 'string') {
      value = isEnum ? `${encode(value)}` : `"${encode(value)}"`
    }

    if (Array.isArray(value)) {
      let valueArray: any[] = value
      valueArray = valueArray.filter((val) => !(val === undefined || val === null))

      if (!valueArray.length) {
        return query
      }

      valueArray = valueArray.map((val) => {
        if (typeof val === 'string') {
          return isEnum ? `${encode(val)}` : `"${encode(val)}"`
        }

        return val
      })

      value = `[${valueArray.join(', ')}]`
    }
    else if (typeof value === 'object') {
      const hasEnum = Object.keys(value).includes('isEnum')

      if (!hasEnum) {
        const queryParamsKeysArray = Object.keys(value)
        const reduceFunc = reduceMethod(value, queryParamsKeysArray, isEnum)

        value = `{${Object.keys(value).reduce(reduceFunc, ``)}}`
      }
      else if (typeof value.value === 'string') {
        value = `${encode(value.value)}`
      }
      else if (value.value || value.value === false) {
        // eslint-disable-next-line
        value = value.value
      }
      else {
        return query
      }
    }

    // for last item
    if (queryParamsKeysArray.length === currentIndex + 1) {
      return query += `${param}: ${value}`
    }

    return query += `${param}: ${value}, `
  }

/**
 * Get Query Params For Graphql
 *
 * const query = getGqlQuery('products', {
 *   groups: [ 'Perfumes' ],
 *   availableForQueue: true,
 *   productsFeed: 'ALL_PERFUMES',
 * })
 *
 * // `products(groups: [ "Perfumes" ], availableForQueue: true, productsFeed: "ALL_PERFUMES")`
 *
 * request.post('graphql', {
 *   body: {
 *     query: `{
 *       ${query} {
 *         id
 *         name
 *         brand
 *       }
 *     }`,
 *   },
 * })
 */
const trim = (params) => Object.keys(params).reduce((result, current) => {
  const value = params[current]

  if (value && typeof value === 'object' && !Array.isArray(value)) {
    const hasEnum = Object.keys(value).includes('isEnum')

    if (!hasEnum) {
      result[current] = trim(value)
    }
    else if (value.value || value.value === false) {
      result[current] = {
        value: value.value,
        isEnum: true,
      }
    }
  }
  else if (typeof value !== 'undefined' && value !== null && value !== '') {
    result[current] = value
  }

  return result
}, {})

const getGqlQuery = (name: string, params: { [key: string]: any }, isEnum = false): string => {
  if (params && typeof params === 'object' && !Array.isArray(params)) {
    const trimParams            = trim(params)
    const queryParamsKeysArray  = Object.keys(trimParams)

    const reduceFunc        = reduceMethod(trimParams, queryParamsKeysArray, isEnum)
    const gqlQuery: string  = queryParamsKeysArray.reduce(reduceFunc, ``)

    return gqlQuery ? `${name}(${gqlQuery})` : `${name}`
  }

  console.warn('helpers/getters/getGqlQuery: params is not object type')
  return ''
}


export default getGqlQuery
